import { useToast } from '@chakra-ui/react';

interface ToastProps {
  step: number;
  action: string;
  errorText?: string;
  helpText?: string;
  successText?: string;
}

export function useCustomToast() {
  const toast = useToast();

  const handleToast = ({
    step,
    action,
    errorText,
    helpText,
    successText,
  }: ToastProps) => {
    const status = (): {
      id: string;
      title: string;
      description: string;
      status: 'warning' | 'error' | 'success';
    } => {
      switch (step) {
        case 0:
          return {
            id: action,
            title: 'O serviço solicitado se encontra fora do ar',
            description:
              'O serviço [0] se encontra indisponível, se persistir contate o suporte',
            status: 'warning',
          };

        case 1:
          return {
            id: action,
            title: 'O serviço solicitado se encontra fora do ar',
            description:
              'O serviço [1] se encontra indisponível, se persistir contate o suporte',
            status: 'warning',
          };

        case 2:
          return {
            id: action,
            title: `Ocorreu um erro ao ${action}`,
            description:
              errorText ||
              'Ocorreu um erro inesperado, se persistir contate o suporte [0]',
            status: 'error',
          };

        case 3:
          return {
            id: action,
            title: `Ocorreu um erro ao ${action}`,
            description:
              errorText ||
              'Ocorreu um erro inesperado, se persistir contate o suporte [1]',
            status: 'error',
          };

        case 4:
          return {
            id: action,
            title: `Ocorreu um erro ao ${action}`,
            description:
              helpText ||
              'Ocorreu um erro inesperado, se persistir contate o suporte',
            status: 'error',
          };

        case 5:
          return {
            id: action,
            title: action,
            description: successText || '',
            status: 'success',
          };

        default:
          return {
            id: 'Erro',
            title: 'Ocorreu um erro inesperado',
            description:
              'Ocorreu um erro inesperado, se persistir contate o suporte',
            status: 'error',
          };
      }
    };

    if (!toast.isActive(action)) {
      toast({
        ...status(),
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return { handleToast };
}
